<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
      :loading="loading"
    />

    <v-row>
      <v-col cols="12" sm="12" md="8">
        <v-text-field
              v-model="entry.name"
              v-bind="getObject('name')"
              label="Nome"
              autocomplete="off"
              :disabled="readOnly"
            />
      </v-col>    

      <v-col cols="12" class="" v-if="items.length > 0">
        <MultiSelect
          v-model="entry.storageItemLotIdsAttribute"
          v-bind="getObject('storageItemLotIdsAttribute')"
          label="Insumo(s)"
          :items="items"
          :loadingItems="itemsListLoading"
          itemSubText="additionalInfo"
          itemSecondSubText="secondAdditionalInfo"
          :maxLimit="null"
          :readOnly="readOnly"
        >          
        </MultiSelect>
      </v-col>    

    </v-row>

  </v-form>
</template>

<script>

// import gql from 'graphql-tag';
import MultiSelect from "@shared_components/multi_select.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      addressError: false,
      items: [],
      itemsListLoading: false,
      loading: false,
      pageLoading: false,
      periodsErrors: []
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },    
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    BaseUtil: BaseUtil,
  },
  created() {
    // this.entry.itemIds = [];
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    this.loadItems();
    // this.selectOperationType(false, true);
  },
  mounted() {
  },
  watch: {
    // "entry.itemIds": function() {
    //   console.log("Alterou entry.itemIds", this.entry.itemIds);
    //   this.entry.items.push(this.items.slice(-1));
    // },
    // "entry.itemIds": {
    //   handler: function() {
    //     console.log("Alterou entry.itemIds", this.entry.itemIds);
    //     this.entry.items.push(this.items.find( (item) => item.id == this.entry.itemIds.slice(0)[0]));
    //   },
    //   deep: true,
    // },
  },
  methods: {
    loadItems: function(){      
        // this.itemsListLoading = true;
        this.items = this.extraData.accountContext.allItemsInStorage;
    },
    addItem: function(){

    } ,   
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },         
  }
};

</script>

<style scoped></style>
